export default "__VITE_ASSET__CY64fa2N__"